var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"vp__chart_dialog"},[_c('BarChart',{attrs:{"chartData":_vm.newBarChartData,"stacked":"","yTitle":"","xTitle":"","isHorizontal":_vm.isBarChartHorizontal}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }